import axios from "../../constents/axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FaCopy } from "react-icons/fa6";
import EditEvent from "./Options/EditEvent";
import DeleteEvent from "./Options/DeleteEvent";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState(null);
  const [eventTitle, setEventTitle] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getEvents = async () => {
    try {
      const response = await axios.get("/events/getEvents");
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const handleEditOpen = (id) => {
    setEventId(id);
    setShowEditModal(true);
  }
  const handleEditClose = () => setShowEditModal(false);

  const handleDeleteOpen = (id, title) => {
    setEventId(id);
    setEventTitle(title);
    setShowDeleteModal(true);
  }
  const handleDeleteClose = () => setShowDeleteModal(false);

  const handleCopyLink = (eventLink) => {
    navigator.clipboard.writeText(eventLink);
  };

  useEffect(() => {
    getEvents();
  }, []);

  return (
    <div style={{ width: "100%", padding: "20px", height: "100vh", overflowY: "auto" }}>
      <div className="d-flex justify-content-between align-items-center">
        <h1>Events</h1>
        <a className="btn btn-primary" href="/CreateEvent">
          Create Event
        </a>
      </div>
      <Table bordered>
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Description</th>
            <th>Event Date</th>
            <th>Join Text</th>
            <th>Desktop Image</th>
            <th>Phone Image</th>
            <th>Button Colour</th>
            <th>Button Text</th>
            <th>Event Link</th>
            <th>Options</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event, index) => (
            <tr key={event.id}>
              <td>{index + 1}</td>
              <td
                style={{
                  minWidth: "100px",
                  maxWidth: "100px",  // Set a max width to control overflow
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={event.title}
              >
                {event.title}
              </td>
              <td
  style={{
    minWidth: "100px",
    maxWidth: "100px",  // Set a max width to control overflow
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",  // Prevents wrapping
  }}
  title={event.description}
>
  {event.description}
</td>
              <td
                style={{
                  minWidth: "60px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {new Date(event.event_date).toLocaleString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}
              </td>
              <td
                style={{
                  maxWidth: "60px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {event.join_text}
              </td>
              <td>
                <img src={event.image_url_desktop} alt="Desktop" width="50" />
              </td>
              <td>
                <img src={event.image_url_mobile} alt="Mobile" width="50" />
              </td>
              <td>
                {event.button_color}
                <input type="color" value={event.button_color} readOnly />
              </td>
              <td
                style={{
                  minWidth: "70px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {event.button_text}
              </td>
              <td className="" style={{ maxWidth: "100px", wordWrap: "break-word", whiteSpace: "normal" }}>
                <a
                  href={`https://aifer.in/events#${event.url_action}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://aifer.in/events#{event.url_action}
                </a>
                <button
                  className="btn btn-primary ms-2"
                  onClick={() =>
                    handleCopyLink(
                      `https://aifer.in/events#${event.url_action}`
                    )
                  }
                >
                  <FaCopy />
                </button>
              </td>
              <td className="d-flex gap-2">
                <button onClick={handleEditOpen.bind(this, event.id)} className="btn btn-primary">Edit</button>
                <button onClick={handleDeleteOpen.bind(this, event.id, event.title)} className="btn btn-danger">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {showEditModal && <EditEvent handleClose={handleEditClose} eventId={eventId} getEvents={getEvents} />}
      {showDeleteModal && <DeleteEvent handleClose={handleDeleteClose} eventId={eventId} eventTitle={eventTitle} getEvents={getEvents} />}
    </div>
  );
};

export default Events;
